/** @format */
import { _$ } from '@king-design/react'

import React, {  useMemo, useState } from 'react'
import styled from 'styled-components'
import {
  ArrayCards,
  ArrayTable,
  Cascader,
  Checkbox,
  DatePicker,
  Editable,
  Form,
  FormButtonGroup,
  FormCollapse,
  FormGrid,
  FormItem,
  FormLayout,
  FormTab,
  Input,
  NumberPicker,
  Password,
  PreviewText,
  Radio,
  Reset,
  Select,
  Space,
  Submit,
  Switch,
  TimePicker,
  Transfer,
  TreeSelect,
  Upload
} from '@formily/antd'
import { createForm } from '@formily/core'
import { createSchemaField } from '@formily/react'
import { Button, Card, Rate, Slider } from 'antd'

const Text: React.FC<{
  value?: string
  content?: string
  mode?: 'normal' | 'h1' | 'h2' | 'h3' | 'p'
}> = ({ value, mode, content, ...props }) => {
  const tagName = mode === 'normal' || !mode ? 'div' : mode
  return React.createElement(tagName, props, value || content)
}
const SchemaField = createSchemaField({
  components: {
    Space,
    FormGrid,
    FormLayout,
    FormTab,
    FormCollapse,
    ArrayTable,
    ArrayCards,
    FormItem,
    DatePicker,
    Checkbox,
    Cascader,
    Editable,
    Input,
    Text,
    NumberPicker,
    Switch,
    Password,
    PreviewText,
    Radio,
    Reset,
    Select,
    Submit,
    TimePicker,
    Transfer,
    TreeSelect,
    Upload,
    Card,
    Slider,
    Rate
  }
})
interface LaunchFormProps {
  className?: string
  formSchema: string
  onCallback: (values) => void
  submitText?: string
  hasPreview?: boolean
  defaultValue?: Record<string, unknown>
}

const getFormSchema = data => {
  try {
    return JSON.parse(data)
  } catch (error) {
    return {}
  }
}
const LaunchForm: React.FC<LaunchFormProps> = ({
  className,
  formSchema,
  onCallback,
  submitText,
  hasPreview = false,
  defaultValue = {}
}) => {
  const [isPreview, setIsPreview] = useState(false)
  const jsonTree = useMemo(() => getFormSchema(formSchema), [formSchema]) // 获取表单数据

  const form = useMemo(() => {
    return createForm({ initialValues: defaultValue })
  }, [jsonTree, defaultValue])

  return (
    <div className={className}>
      <Form form={form} {...jsonTree.form}>
        <SchemaField schema={jsonTree.schema} />
        {onCallback && (
          <FormButtonGroup.Sticky align="right">
            <FormButtonGroup>
              {hasPreview ? (
                !isPreview ? (
                  <Button
                    type="primary"
                    onClick={() => {
                      form.validate().then(() => {
                        form.setPattern('readPretty')
                        setIsPreview(true)
                      })
                    }}
                  >
                    {_$("预览")}
                  </Button>
                ) : (
                  <>
                    <Button
                      onClick={() => {
                        form.setPattern('editable')
                        setIsPreview(false)
                      }}
                    >
                      {_$("上一步")}
                    </Button>
                    {submitText && (
                      <Button
                        type="primary"
                        onClick={async () => {
                          const result = await form.submit()
                          onCallback && onCallback(result)
                        }}
                      >
                        {submitText}
                      </Button>
                    )}
                  </>
                )
              ) : (
                submitText && (
                  <Button
                    type="primary"
                    onClick={async () => {
                      const result = await form.submit()
                      onCallback && onCallback(result)
                    }}
                  >
                    {submitText}
                  </Button>
                )
              )}
            </FormButtonGroup>
          </FormButtonGroup.Sticky>
        )}
      </Form>
    </div>
  )
}

export default styled(LaunchForm)``
